<template>
  <div
    v-if="tournament && tournament.name"
    style="padding: 10px;border: 2px solid #e8e8e8; border-radius: 20px;"
  >
    <p v-show="tournament.name" class="title is-3" style="color: green;">
      {{ tournament.name }}
      <span v-if="tournament.recurrence && tournament.recurrence.repeat">
        {{
          tournament.startTime
            | asDayjsFormat(
              `DD/MM/YYYY${
                tournament.recurrence.repeat.basis === "minute" ? " HH:mm" : ""
              }`
            )
        }}
      </span>
    </p>

    <div class="is-flex is-justify-content-center">
      <span v-if="tournament.reward" class="is-flex">
        <Trophy
          v-if="tournament.rewardParticipation"
          text="Participation"
          class="mx-1"
        />
        <Trophy :text="`${tournament.reward}|3`" class="mx-1" />
        <Trophy :text="`${tournament.reward}|2`" class="mx-1" />
        <Trophy :text="`${tournament.reward}|1`" class="mx-1" />
      </span>
      <p class="subtitle is-4">{{ roundText() }} {{ timeText() }}</p>
      <span v-if="tournament.reward" class="is-flex">
        <Trophy :text="`${tournament.reward}|1`" class="mx-1" />
        <Trophy :text="`${tournament.reward}|2`" class="mx-1" />
        <Trophy :text="`${tournament.reward}|3`" class="mx-1" />
        <Trophy
          v-if="tournament.rewardParticipation"
          text="Participation"
          class="mx-1"
        />
      </span>
    </div>

    <p class="subtitle is-5 has-text-itatic">
      {{ tournament.startTime | asDateTime("dddd, D MMMM, YYYY hh:mm A") }}
    </p>
  </div>
</template>

<script>
import Trophy from "../stats/Trophy.vue";

export default {
  components: { Trophy },

  props: ["tournament"],

  methods: {
    roundText() {
      const currentRound = Math.min(
        this.tournament.currentRound,
        this.tournament.totalRounds
      );
      return `${currentRound}/${this.tournament.totalRounds} rounds ${
        this.tournament.type ? this.tournament.type : "Swiss"
      }`;
    },

    timeText() {
      return `${this.tournament.baseTimeControl}+${this.tournament.increment}`;
    },
  },
};
</script>

<style></style>
